import { useEffect, useState } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { api, formatApiErrorDetail } from "../lib/api";
import { useAuth } from "../lib/auth";
import LegalFooter from "../components/LegalFooter";

export default function AcceptInvite() {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, refresh } = useAuth();
  const token = new URLSearchParams(location.search).get("token") || "";
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);

  useEffect(() => {
    if (user === null) return;
    if (user === false) return;
    (async () => {
      try {
        const { data } = await api.post("/companies/invites/accept", { token });
        await refresh();
        setDone(true);
        setTimeout(() => navigate("/app/dashboard"), 1200);
      } catch (e) {
        setError(formatApiErrorDetail(e.response?.data?.detail) || e.message);
      }
    })();
  }, [user, token]);

  if (user === false) {
    return (
      <div className="auth-shell">
        <div className="auth-card">
          <h1 className="mb-2">Accept invite</h1>
          <p className="text-[13px] mb-4">You need an account to accept this invite. Sign up using the same email it was sent to.</p>
          <Link to={`/signup`} className="btn-primary inline-block">Create account</Link>
          <p className="text-[12px] mt-4">Already have one? <Link to="/login" className="underline">Sign in</Link></p>
        </div>
        <LegalFooter variant="fixed" />
      </div>
    );
  }

  return (
    <div className="auth-shell">
      <div className="auth-card">
        <h1 className="mb-2">Accept invite</h1>
        {done ? <p>Joined! Redirecting…</p> : error ? <p className="text-[13px]">{error}</p> : <span className="spinner" />}
      </div>
      <LegalFooter variant="fixed" />
    </div>
  );
}
